import { render, staticRenderFns } from "./InstitucionalSliderTemasGlideEn.vue?vue&type=template&id=847c047e&"
import script from "./InstitucionalSliderTemasGlideEn.vue?vue&type=script&lang=js&"
export * from "./InstitucionalSliderTemasGlideEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports